function titleCase (str: string | undefined | null) {
  if (!str) return str

  return str.toLowerCase().split(' ').map(word => {
    return word.charAt(0).toUpperCase() + word.slice(1)
  }).join(' ')
}

export default titleCase
